import { Input, InputNumber, Select } from 'antd';

Input.defaultProps.maxLength = 255;
// Input.TextArea.defaultProps.maxLength = '1000';
InputNumber.defaultProps.min = 0;
InputNumber.defaultProps.max = 10000;
Select.defaultProps.getPopupContainer = trigger => trigger.parentNode;



// WEBPACK FOOTER //
// ./src/defaultProps.js